module.exports = __webpack_public_path__ + "img/36.72bfc260.jpg";